import "./TemplateCard.less";

import { Button, Card, Input, Modal, Spin } from "antd";
import * as React from "react";

import { IBaseProps } from "lib/data/interfaces";
import { RequirementItem, SingleItemRequirement } from "lib/data/model";
import { ComponentTemplate, DataFieldTemplate } from "lib/data/model";
import { Requiredness } from "lib/data/model/enumerations";

import { DeleteButton, EditButton, ExpandButton } from "../StandardButtons";
import { actionTypes } from "./ActionTypes";
import { Cover } from "./Cover";

interface ITemplateCardProps extends IBaseProps {
	canEditTitle?: boolean;
	updateTitle?: (newTitle: string, callback?: () => void) => void;
	highlighted?: boolean;
	repeatable?: boolean;
	required?: boolean;
	requirement?: RequirementItem<ComponentTemplate> | RequirementItem<DataFieldTemplate>;
	onCheckboxclick?: () => void;
	showCheckboxes: boolean;
	multiRequirementColor?: string;
	multiItemRequirementId?: number;
	highlightOnClick?: boolean;
	border?: boolean;
	title: string;
	templateType: string;
	templateSubType?: string;
	iconType?: string;
	actionbuttons?: actionTypes[];
	actionButtonClick?: (command: actionTypes, id?: number) => void;
	onCardSelect?: () => void;
	className?: string;
	index?: number;
	id?: number;
}
interface ITemplateCardState {
	repeatable: boolean;
	required: boolean;
	highlighted: boolean;
	isEditingTitle: boolean;
	title: string;
	awaitingUpdate: boolean;
}

export class TemplateCard extends React.Component<ITemplateCardProps, ITemplateCardState> {

	public static readonly BasePath: string = "/admin/templateeditor";

	private renderActionButton = {
		edit: (key: number) =>
			(
				<div className="action-button" key={key}>
					<EditButton
						className={String(this.props.multiItemRequirementId)}
						onMouseOver={() => this.addActiveClassToCard("active-multi-req-card-edit", "inactive-multi-req-card")}
						onMouseOut={() => this.removeActiveClassFromCard("active-multi-req-card-edit", "inactive-multi-req-card")}
						onClick={() => this.props.actionButtonClick ? this.props.actionButtonClick("edit") : null} />
				</div>
			),
		delete: (key: number) =>
			(
				<div className="action-button" key={key}>
					<DeleteButton
						onMouseOver={() => this.addActiveClassToCard("active-multi-req-card-delete", "inactive-multi-req-card")}
						onMouseOut={() => this.removeActiveClassFromCard("active-multi-req-card-delete", "inactive-multi-req-card")}
						onClick={() => this.props.actionButtonClick ? this.props.actionButtonClick("delete") : null} />
				</div>
			),
		expand: (key: number) =>
			(
				<div className="action-button" key={key}>
					<ExpandButton
						className={String(this.props.multiItemRequirementId)}
						onMouseOver={() => this.addActiveClassToCard("active-multi-req-card-edit", "inactive-multi-req-card")}
						onMouseOut={() => this.removeActiveClassFromCard("active-multi-req-card-edit", "inactive-multi-req-card")}
						onClick={() => this.props.actionButtonClick ? this.props.actionButtonClick("expand") : null} />
				</div>
			),
	};

	public constructor(props: ITemplateCardProps) {

		super(props);

		this.state = {
			repeatable: props.repeatable || false,
			required: props.required || false,
			highlighted: this.props.highlighted ? this.props.highlighted : false,
			isEditingTitle: false,
			title: this.props.title,
			awaitingUpdate: false,
		};
	}

	public render() {
		return (
			<Card
				key={this.props.index}
				onClick={this.onCardClick}
				className={`template-card ${this.props.className || ""} ${this.props.multiItemRequirementId || ""}${this.state.highlighted ? " highlighted" : ""}${this.props.border ? " border" : ""}`}
				bordered={false}
				style={{ width: 150 }}
				cover={
					<Cover
						index={this.props.index}
						iconType={this.props.iconType}
						repeatable={(
							this.props.requirement && this.props.requirement.owningRequirement.$type === SingleItemRequirement.$type.ComponentTemplate
								?
								(this.props.requirement.owningRequirement as SingleItemRequirement<ComponentTemplate>).isRepeatable
								:
								(
									this.props.requirement && this.props.requirement.owningRequirement.$type === SingleItemRequirement.$type.DataFieldTemplate
										?
										(this.props.requirement.owningRequirement as SingleItemRequirement<DataFieldTemplate>).isRepeatable
										:
										undefined
								)
						)}
						requiredness={this.props.requirement ? this.props.requirement.owningRequirement.requiredness : Requiredness.OPTIONAL}
						onChangeRequired={this.onChangeRequired}
						onChangeRepeatable={this.onChangeRepeatable}
						disabledCheckboxes={this.props.multiItemRequirementId != null}
						showCheckboxes={this.props.showCheckboxes}
					/>
				}
			>
				{/* render the actions passed in */}
				<div className="action-button-container">
					{this.props.actionbuttons ?
						this.props.actionbuttons.map((item, key) => this.renderActionButton[item](key))
						: null}
				</div>

				<div className="ant-card-meta template-card-title-section overflow-meta-title">
					<div className="ant-card-meta-detail">
						{this.props.canEditTitle && this.props.updateTitle != undefined ?
							<div className="ant-card-meta-title meta-title-edit">
								<Modal
									className="edit-template-card-name"
									visible={this.state.isEditingTitle}
									onCancel={() => { if (!this.state.awaitingUpdate) { this.setState({ isEditingTitle: false }); } }}
									footer={[<Button key={`modal-button-${1}`} onClick={() => this.setState({ isEditingTitle: false })}>Cancel</Button>
										, <Button key={`modal-button-${2}`} type="primary" onClick={this.updateTitle}>Save</Button>]}
								>
									{this.state.awaitingUpdate ?
										<Spin /> :
										<Input onChange={this.inputTitleHandler} value={this.state.title} />
									}
								</Modal>
								<EditButton className="title-edit-button" onClick={() => this.setState({ isEditingTitle: true })} />
								{this.props.title}

							</div>
							:
							<div className="ant-card-meta-title" >
								{this.props.title}
							</div>
						}
						<div className="ant-card-meta-description">
							{this.props.templateType}
							{this.props.templateSubType ? <div className="sub-type">{this.props.templateSubType}</div> : null}
						</div>
					</div>
				</div>

				{(
					this.props.multiRequirementColor
						?
						<div
							className="requirement-bar"
							style={{ background: this.props.multiRequirementColor }}
						/>
						:
						null
				)}

			</Card>
		);
	}

	public componentDidMount = () => {

		this.setState({
			repeatable: this.props.repeatable || false,
			required: this.props.required || false,
		});

	}

	public componentWillReceiveProps = (nextProps: ITemplateCardProps) => {

		this.setState({
			repeatable: nextProps.repeatable || false,
			required: nextProps.required || false,
			title: nextProps.title,
		});

	}

	private onChangeRepeatable = async () => {

		if (this.props.requirement
			&& this.props.onCheckboxclick
			&& this.props.requirement
			&& this.props.requirement.owningRequirement.$type === SingleItemRequirement.$type.ComponentTemplate) {

			// Get Current Value
			const isRepeatable = (this.props.requirement.owningRequirement as SingleItemRequirement<ComponentTemplate>).isRepeatable;

			(this.props.requirement.owningRequirement as SingleItemRequirement<ComponentTemplate>).isRepeatable = !isRepeatable;
			this.props.onCheckboxclick();
		}
		else if (this.props.requirement
			&& this.props.onCheckboxclick
			&& this.props.requirement
			&& this.props.requirement.owningRequirement.$type === SingleItemRequirement.$type.DataFieldTemplate) {

			// Get Current Value
			const isRepeatable = (this.props.requirement.owningRequirement as SingleItemRequirement<DataFieldTemplate>).isRepeatable;

			(this.props.requirement.owningRequirement as SingleItemRequirement<DataFieldTemplate>).isRepeatable = !isRepeatable;
			this.props.onCheckboxclick();
		}
	}

	private onChangeRequired = async () => {

		if (this.props.requirement && this.props.onCheckboxclick) {

			this.props.requirement.owningRequirement.requiredness = this.props.requirement.owningRequirement.requiredness === Requiredness.OPTIONAL ? Requiredness.REQUIRED : Requiredness.OPTIONAL;
			this.props.onCheckboxclick();
		}
	}

	private addActiveClassToCard = (activeClassName: string, inactiveClassName: string) => {

		// if this is for a multi Item requirement
		if (this.props.multiItemRequirementId != null) {

			// grab all the card with the requirment id class name
			const allTemplateCards = document.getElementsByClassName(`template-card`);
			const activeTemplateCards = document.getElementsByClassName(`template-card ${this.props.multiItemRequirementId}`);

			for (const element of Array.from(allTemplateCards)) {

				element.classList.add(inactiveClassName);
				element.classList.add("inactive-multi-req-card");
			}

			for (const element of Array.from(activeTemplateCards)) {

				element.classList.remove(inactiveClassName);
				element.classList.add(activeClassName);
				element.classList.add("active-multi-req-card");
			}
		}
	}

	private removeActiveClassFromCard = (activeClassName: string, inactiveClassName: string) => {

		// if this is for a multi Item requirement
		if (this.props.multiItemRequirementId != null) {

			// grab all the card with the requirment id class name
			const allTemplateCards = document.getElementsByClassName(`template-card`);
			const activeTemplateCards = document.getElementsByClassName(`template-card ${this.props.multiItemRequirementId}`);

			for (const element of Array.from(allTemplateCards)) {

				element.classList.remove(inactiveClassName);
			}

			for (const element of Array.from(activeTemplateCards)) {

				element.classList.remove(activeClassName);
			}
		}
	}

	private onCardClick = () => {

		if (this.props.onCardSelect != null) {
			this.props.onCardSelect();
		}

		if (this.props.highlightOnClick != null) {
			let { highlighted } = this.state;
			highlighted = !highlighted;
			this.setState({ highlighted });
		}
	}

	private inputTitleHandler = (event: React.ChangeEvent<HTMLInputElement>) => {

		const { value } = event.target;
		this.setState({ title: value });
	}

	private updateTitle = () => {

		this.setState({ awaitingUpdate: true });

		if (this.props.updateTitle) {

			this.props.updateTitle(this.state.title, () => {

				this.setState({ awaitingUpdate: false, isEditingTitle: false });
			});
		}
	}
}
